import React, { useMemo } from 'react';

import Select from '../../../../components/Blackbird/Forms/Select/Select';
import { getSelectValuesWithAllUTCs } from '../../../../utils/Timezones/Timezones';
import { FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';

interface Props {
  errors: FieldErrors<FieldValues>;
  register: UseFormRegister<FieldValues>;
}

interface TimezoneOption {
  value: string;
  label: string;
}

export default function TimeZoneSelect({ register, errors }: Props) {
  const timezoneOpts = useMemo<TimezoneOption[]>(
    // @ts-ignore
    () => getSelectValuesWithAllUTCs(),
    []
  );

  return (
    <Select
      containerProps={{
        'data-testid': 'timezone-select-container',
      }}
      label={'Time Zone'}
      errors={errors}
      showErrorMessageBelow
      inputName={'ingestionSchedule.0.timezone'}
      selectProps={{
        ...register('ingestionSchedule.0.timezone', {
          required: 'Select a timezone',
        }),
        'data-testid': 'timezone-select',
      }}
    >
      {timezoneOpts.map((item: { value: string; label: string }, index: number) => (
        <option key={index} value={item.value}>
          {item.label}
        </option>
      ))}
    </Select>
  );
}
